
import "./styles.css";
const YCard = (props) => {
    return(
        <div className='y-Card' style={{background:props.color}}>
            <div style ={{fontWeight:600, fontSize:'16px', paddingTop:'10px'}}>
             {props.name}
            </div>
            <div class="numberCircle">{props.num}</div>
        </div>
    )
}

export default YCard